import React, { useState } from 'react';
import { Form, Input, Button, notification } from 'antd';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebase.config';
import Container from '../../style/container';
import { useNavigate } from 'react-router-dom';
import { openError, openSuccess } from '../../utils/helper/message';

const { Item } = Form;

const ForgotPasswordPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const handleReset = async ({ email }) => {
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email, {
        //url: 'http://localhost:3000/signin',
        url: 'http://mogul-cloud-dev.pages.dev/signin',
      });
      openSuccess(api, 'Password reset email sent');
      form.resetFields();
    } catch (error) {
      openError(api, error.message || 'Failed to send reset email');
    }
    setLoading(false);
  };

  return (
    <Container>
      {contextHolder}
      <div
        style={{
          minHeight: '79vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '400px',
            padding: '32px',
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 0 20px rgba(0,0,0,0.1)',
          }}
        >
          <Form layout="vertical" form={form} onFinish={handleReset}>
            <Item>
              <h2 style={{ textAlign: 'center' }}>Password Reset</h2>
            </Item>
            <Item
              name="email"
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Enter a valid email',
                },
              ]}
            >
              <Input placeholder="Enter your email" size="large" />
            </Item>
            <Item>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={loading}
                size="large"
              >
                Send Reset Email
              </Button>
            </Item>
            <Item>
              <Button type="link" block onClick={() => navigate('/signin')}>
                Back to Sign In
              </Button>
            </Item>
          </Form>
        </div>
      </div>
    </Container>
  );
};

export default ForgotPasswordPage;
